import React, { Component } from 'react'
import { TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_7 } from '../../../../../../config/tables'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'
import { Container, Row, Col } from 'react-bootstrap'

export class ReporteEmbarqueSector12Linea7View extends Component {
  render () {
    return (

      <Container fluid>
        <Row>
          <Col md={12}>
            <MuiTable id={TABLA_REPORTE_EMBARQUE_SECTOR_12_LINEA_7} />
          </Col>
        </Row>
      </Container>
    )
  }
}
